import { useEffect } from 'react';

/**
 * Stops the page behind an overlay (the mobile sidebar drawer) from scrolling while `locked`.
 * The document root is the page's scroll box (`html` keeps its scrollbar track), so the lock
 * goes there, as the modal lock in `styles.scss` does; clipping the body instead would turn it
 * into the sticky header's scroll box. The root's own value comes back on unlock.
 */
export function usePageScrollLock(locked: boolean): void {
    useEffect(() => {
        if (!locked) return;
        const { style } = document.documentElement;
        const previous = style.getPropertyValue('overflow');
        const previousPriority = style.getPropertyPriority('overflow');
        // Important, as a stylesheet forces the scrollbar track on the root with !important.
        style.setProperty('overflow', 'hidden', 'important');
        return () => {
            style.setProperty('overflow', previous, previousPriority);
        };
    }, [locked]);
}
